import React, { useState, useEffect } from "react";
import * as d3 from "d3";
import { usePapaParse } from "react-papaparse";
import Contestants from "components/Bachelor/Contestants";
import BannerMessage from "components/_ui/BannerMessage/BannerMessage";
import Link from "components/_ui/Link/Link";
import MaxWidth from "components/_ui/MaxWidth/MaxWidth";
import Label from "components/_ui/Label/Label";
//import peterCrownImg from './images/head-peter-crown.png'
import "./Bachelor.scss";

const Bachelor = () => {
    const [parsedContestants, setParsedContestants] = useState([]);
    const [contestantsDataA, setContestantsDataA] = useState([]);
    const [contestantsDataB, setContestantsDataB] = useState([]);
    const [contestantsDataC, setContestantsDataC] = useState([]);
    const { readRemoteFile } = usePapaParse();

    let processData = (data) => {
        let headers = data[0];
        let contestants = data.splice(1, data.length);

        contestants = contestants.map((row) => {
            row = headers.map((foo, index) => {
                return { [foo]: row[index] || false };
            });
            return row;
        });
        return contestants;
    };

    useEffect(() => {
        function fetchData() {
            readRemoteFile("./bachelor-cosmo.csv", {
                download: true,
                complete: (results) => {
                    setContestantsDataA(processData(results.data));
                },
            });

            readRemoteFile("components/Bachelor/data/bachelor-usmag.csv", {
                download: true,
                complete: (results) => {
                    setContestantsDataB(processData(results.data));
                },
            });

            readRemoteFile("components/Bachelor/data/bachelor-abc.csv", {
                download: true,
                complete: (results) => {
                    setContestantsDataC(processData(results.data));
                },
            });

            readRemoteFile("components/Bachelor/data/parsedContestants.csv", {
                download: true,
                complete: (results) => {
                    setParsedContestants(processData(results.data));
                },
            });
        }

        fetchData();
    }, []);

    return (
        <MaxWidth size="l" className="Bachelor">
            <BannerMessage
                github="https://github.com/margueriteroth/rosie-archive/tree/main/src/components/Bachelor"
                reason="archived"
            />
            <div className="screenshots">
                <div>
                    <img src="./bachelor.png" alt="" />
                </div>
                <div>
                    <img src="./bachelor-modal.png" alt="" />
                </div>
            </div>
            <template v-if="false">
                <MaxWidth size="l" className="Bachelor__header">
                    <Link
                        to="https://marguerite.io/"
                        className="Bachelor__home__link"
                    >
                        <Label category="primary">← Marguerite.io</Label>
                    </Link>
                    <h1 className="Bachelor__header__title">The Bachelor</h1>
                    <h3 className="Bachelor__header__description">
                        Welcome Bachelor Nation. Following along with the new
                        contestants is hard—this guide is here to help! 🌹
                    </h3>
                    <div className="Bachelor__header__message">
                        <h3>And we have a winner...</h3>
                        <p>Hanna Ann... wins?</p>
                        <p>Peter is Arie. Madison wins.</p>
                        <p>Peter quarantines with Kelley. ¯\_(ツ)_/¯</p>
                    </div>

                    {/* <img className="Bachelor__header__peter" src={peterCrownImg} />
                <h4 className="Bachelor__header__name">
                    Peter Weber, 28
                </h4>
                <div className="Bachelor__header__description">
                    <span>
                        <FontAwesomeIcon className="" icon={faMapMarkerAlt} /> Westlake Village, CA
                    </span>
                    <span>
                        ✈️ Airline Pilot
                    </span>
                    <span>
                        🌹Hannah’s Season
                    </span>
                </div> */}
                </MaxWidth>
                <MaxWidth size="l" className="Bachelor__contestants">
                    <Contestants
                        parsedContestants={parsedContestants}
                        contestantsDataA={contestantsDataA}
                        contestantsDataB={contestantsDataB}
                    />
                </MaxWidth>
                <MaxWidth size="l" className="Bachelor__inspo">
                    <h6>
                        <Link
                            doOpenInNewTab
                            to="https://robhasawebsite.com/shows/reality-tv-rhapups/bachelor-bachelorette-paradise/bachelor-2/"
                        >
                            Inspired by the Bachelor RHAP UP podcast 🌹
                        </Link>
                    </h6>
                </MaxWidth>
                <MaxWidth
                    size="xl"
                    className="Bachelor__back-button__container"
                >
                    <Link to="/" isButton className="Bachelor__back-button">
                        ← Back to Marguerite.io
                    </Link>
                </MaxWidth>
                <MaxWidth size="xl" className="Bachelor__inspo">
                    <Link
                        doOpenInNewTab
                        to="https://github.com/margueriteroth/rosie/tree/master/src/components/Bachelor"
                        className="Bachelor__code"
                    >
                        Bachelor code
                    </Link>
                </MaxWidth>
                <MaxWidth size="xl" className="Bachelor__attributions">
                    <h5 className="Bachelor__attributions__title">
                        Contestant image, name, age, occupation, and location
                        information from:
                    </h5>
                    <p>
                        Us Magazine:{" "}
                        <Link to="https://www.usmagazine.com/entertainment/pictures/the-bachelor-season-24-cast-meet-peter-webers-contestants">
                            https://www.usmagazine.com/entertainment/pictures/the-bachelor-season-24-cast-meet-peter-webers-contestants
                        </Link>
                    </p>
                    <p>
                        Cosmopolitan:{" "}
                        <Link to="https://www.cosmopolitan.com/entertainment/tv/g29087999/peter-weber-bachelor-contestants-season-24-2020/">
                            https://www.cosmopolitan.com/entertainment/tv/g29087999/peter-weber-bachelor-contestants-season-24-2020/
                        </Link>
                    </p>
                    <p>
                        ABC:{" "}
                        <Link to="https://abc.com/shows/the-bachelor">
                            https://abc.com/shows/the-bachelor
                        </Link>
                    </p>
                </MaxWidth>
            </template>
        </MaxWidth>
    );
};

export default Bachelor;

// const getParsedContestants = async () => {
//     const contestantsData = await Promise.all(
//         contestantsDataA.map(async (d, i) => {
//             let location = d.location
//             let url = api_url
//                 + '?'
//                 + 'api_key=' + geoapikey
//                 + '&q=' + encodeURIComponent(location)

//             const res = await fetch(url)
//             const json = await res.json()

//             let name = contestantsDataB[i].name

//             //Canada!
//             let lat = name !== "Mykenna" ? json.results[0].location.lat : 48.993867
//             let lng = name !== "Mykenna" ? json.results[0].location.lng : -122.672326

//             return {
//                 ...d,
//                 lat,
//                 lng,
//                 name,
//                 image: contestantsDataB[i]["image-src"]
//             }
//         })
//     )

//     setParsedContestants(contestantsData);
// };
